module.exports = __webpack_public_path__ + "static/media/NVPC.847a66d2.png";